<script setup lang="ts">
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import { useGetContacts } from "@/contacts/contactsCrud";
import ContactsTable from "@/contacts/ContactsTable.vue";
import type { House } from "./types";

const props = defineProps<{
  house: House;
}>();

const { contacts, getContactsStatus } = useGetContacts(props.house.id);
</script>
<template>
  <HandleQueryStatus :query-status="getContactsStatus">
    <div class="container container-lg">
      <ContactsTable :contacts="contacts ?? []" />
    </div>
  </HandleQueryStatus>
</template>
